import { useQuery, type UseQueryOptions } from '@tanstack/react-query';
import { getMeByPayroll, type MeResponse } from '@Shared/profile/profile.service';

export const useImpersonatedUserQuery = (
  payrollNumber: string,
  token: string,
  queryOptions?: Omit<UseQueryOptions<MeResponse>, 'queryKey' | 'queryFn'>
) => {
  return useQuery({
    queryKey: ['impersonated_user', payrollNumber, token],
    queryFn: () => getMeByPayroll(payrollNumber),
    ...queryOptions,
  });
};
